import e from"styled-components";import{theme as i}from"../../../../theme.js";const t=e.div`
  display: flex;
  gap: ${i.spacing*4}px;
  align-items: center;
`;export{t as Container};
